import { fmt } from 'components/IntlWrapper/IntlWrapper';

export const SMART_STICKERS_GUIDE_STEPS = [
  {
    title: fmt({ id: 'smart_stickers_guide.steps.step_1.title' }),
    subtitle: fmt(
      { id: 'smart_stickers_guide.steps.step_1.subtitle' },
      {
        span: (children) => (
          <span className="br-smart-stickers-guide__teal-text body-medium">
            {children}
          </span>
        )
      }
    )
  },
  {
    title: fmt({ id: 'smart_stickers_guide.steps.step_2.title' }),
    subtitle: fmt({ id: 'smart_stickers_guide.steps.step_2.subtitle' })
  },
  {
    title: fmt({ id: 'smart_stickers_guide.steps.step_3.title' }),
    subtitle: fmt(
      { id: 'smart_stickers_guide.steps.step_3.subtitle' },
      {
        span: (children) => <span className="body-medium">{children}</span>
      }
    )
  },
  {
    title: fmt({ id: 'smart_stickers_guide.steps.step_4.title' }),
    subtitle: fmt({ id: 'smart_stickers_guide.steps.step_4.subtitle' })
  }
];

export const SMART_STICKERS_GUIDE_VIDEO_URL =
  'https://www.youtube.com/embed/yWdGoQ9Se6k';
